import {
  ConstructionMethodType,
  ConstructionStartType,
  EnergyStandardType,
  ExpansionStageType,
  FinancingStatusType,
  PropertyType,
  UtilizationType
} from '@js/common/types/ProjectTypes'

import { CreateReviewBuildingPhase } from '@f-fertighaus/applications/SalesAgentDashboard/pages/SADBReputationCollection/CreateReviewRequestForm'
import {
  GenderType,
  TOpportunityStatusDetailType,
  TOpportunityStatusType,
  TTaskType
} from '@f-fertighaus/applications/SalesAgentDashboard/SalesAgentDashboardData'

export const OpportunityStatuses: TOpportunityStatusType[] = [
  'open',
  'qualification',
  'meeting_scheduled',
  'planning',
  'offer_made',
  'contract_signed',
  'out'
]

export const OpportunityStatusDetails: TOpportunityStatusDetailType[] = [
  'out_no_property_found',
  'out_no_financing_received',
  'out_purchase_existing_realty_realised',
  'won_other_vendor',
  'out_denial_by_user'
]

export const Gender: GenderType[] = ['m', 'f']

export const ContactPreferences: TContactPreferencesType[] = [
  'unknown',
  'contact_by_sales_agent',
  'get_info_only',
  'contact_details_for_proactive_contact'
]

export const Utilizations: UtilizationType[] = [
  'detached_house',
  'duplex',
  'two_families_house',
  'townhouse',
  'apartment_house',
  'na'
]

export const ExpansionStages: ExpansionStageType[] = [
  'price_ready',
  'price_fitting',
  'price_lego',
  'na'
]

export const EnergyStandards: EnergyStandardType[] = [
  'kfw_55',
  'kfw_40',
  'positive_energy_house',
  'kfw_40_plus',
  'kfw_40_ee',
  'kfw_40_nh',
  'kfw_55_ee',
  'kfw_55_nh'
]

export const ConstructionMethods: ConstructionMethodType[] = [
  'solid',
  'prefab',
  'blockhouse',
  'na'
]

export const ConstructionStarts: ConstructionStartType[] = [
  'as_soon_as_possible',
  'within_1_year',
  'within_1_to_2_years',
  'in_more_than_2_years'
]

export const Properties: PropertyType[] = ['yes', 'no', 'reserved', 'expected']

export const FinancingStatuses: FinancingStatusType[] = [
  'not_requested',
  'requested',
  'clarified',
  'only_equity',
  'na'
]

export const TaskTypes: TTaskType[] = ['email', 'phone', 'consultation']

export const SourceOptions = [
  'platform',
  'other_online_portal',
  'headquarter',
  'model_home_park',
  'phone_email',
  'referral',
  'trade_fair',
  'other'
] as const

export const CreateReviewBuildingPhases: CreateReviewBuildingPhase[] = [
  'info_material_received',
  '1st_sales_rep_call_done',
  '1st_meeting_done',
  'offer_made',
  'contract_signed',
  'moving_in_happened'
]
